module.exports = __webpack_public_path__ + "static/img/shared-card.909c930.png";


//////////////////
// WEBPACK FOOTER
// ./src/RF_assets/cards/shared-card.png
// module id = I9y0
// module chunks = 88